import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { customerservice } from "../../../config";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import { CloudUpload } from "@mui/icons-material";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";

function ApprovedAssetCustomers() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const RoleGroupId = parseInt(decodedToken.RoleGroupId);
  const CompanyId = parseInt(decodedToken.CompanyId);
  let showActivate = false;
  if (CompanyId === 23) {
    if (RoleGroupId === 1 || RoleGroupId === 2) {
      showActivate = true;
    }
  }

  const base_url = customerservice.uri;
  // Define tour steps for the Rights page
  const rightsTourSteps = [
    {
      target: ".dynamic-table-header",
      content:
        "This is the Groups page, where you can manage new and existing Groups.",
      placement: "top",
      disableBeacon: true,
    },
    {
      target: ".dynamic-table-search",
      content:
        "Use the search bar to find specific Groups by name or other criteria.",
      placement: "bottom",
    },
    {
      target: ".dynamic-table-add-button",
      content: "Click this button to add a new Group.",
      placement: "right",
    },
    {
      target: ".edit-action",
      content: "Click this button to edit the Group Details.",
      placement: "right",
    },
    {
      target: ".view-manage-groupaction",
      content: "Click this button to add group members and their roles.",
      placement: "right",
    },
    {
      target: ".dynamic-table-actions",
      content:
        "Select actions like Manage Group or Deactivate for each Group from this dropdown.",
      placement: "left",
    },
  ];
  const ignoreFields = [
    "CompanyName",
    "TitleId",
    "Password",
    "GenderId",
    "DateOfBirth",
    "MaritalStatusId",
    "PostalAddress",
    "PhysicalAddress",
    "ResidenceTypeId",
    "YearsLivedAtResidence",
    "CountyId",
    "WardId",
    "BranchId",
    "RegionId",
    "FieldOfficerId",
    "AccountLocked",
    "LoginAttempts",
    "FirstTimeLogin",
    "LoanLimit",
    "AverageCashSales",
    "DeviceName",
    "DeviceId",
    "UniqueId",
    "LastLoginDateTime",
    "Pin",
    "Otp",
    "PinLastUpdated",
    "DateReactivated",
    "PostalCode",
    "ApprovalComments",
    "AverageSalesApproved",
    "AverageSalesApprovedBy",
    "AverageSalesApprovedDate",
    "AverageSalesReasonForRejection",
    "IdFrontPhoto",
    "IdBackPhoto",
    "CustomerVerified",
    "SelfiePhoto",
    "CustomerDeactivatedBy",
    "DeactivatedDate",
    "IsLoanScheduleGenerated",
    "DateOfLastLimitChange",
    "CreditInfoRecommendation",
    "ApprovedBy",
    "IsIPRSChecked",
    "RegFeePaid",
    "UpdatedBy",
    "MigratedBy",
    "MigrationDate",
    "ServicedLoans",
    "InActiveOLB",
    "Latitude",
    "Longitude",
    "MappedBy",
    "GroupOLB",
  ];
  const columns = [
    { field: "Id", headerName: "CustomerID", flex: 1 },
    { field: "FirstName", headerName: "First Name", flex: 1 },
    { field: "OtherNames", headerName: "Other Names" },
    { field: "MobileNumber", headerName: "Customer Phone" },
    // { field: "EmailAddress", headerName: "Email Address", flex: 1 },
    { field: "IdNoOrPassport", headerName: "Id No Or Passport" },
    { field: "BranchName", headerName: "Branch" },
    { field: "Creator", headerName: "Created By" },
    { field: "DateCreated", headerName: "Created Date", width: 160 },
    {
      field: "ChannelId",
      headerName: "Channel",
      valueGetter: (params) => {
        const value = params.row.ChannelId;
        return value === 1 ? "Mobile" : "Portal";
      },
    },

    {
      field: "IsApproved",
      headerName: "Customer Approved",
      flex: 1,
      renderCell: (params) => (
        <Typography
          style={{
            color: params.value ? "green" : "red",
          }}
        >
          {params.value ? "True" : "False"}
        </Typography>
      ),
    },
  ];

  const actions = {
    entity: "Approved Customer",
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: CompanyId === 23 ? showActivate : true,
      permission: "ActivatePermission",
      modelName: "customerIds", // Specify the model name here
      inputObjectName: "bulkActivateDeactivateCustomers",
    },
    ViewCustomerDetails: {
      key: "VIEWDETAILS",
      button_name: "ADD/View More Details",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4, 5],
    },

    ViewCustomer360: {
      key: "ViewAllCustomerDetails",
      button_name: "View Customer 360",
      Show_Button: true,
      permission: "ActivatePermission",
      roleGroupId: [1, 2, 3, 4, 5],
    },


    // SetLoanLimit: {
    //   key: "SETLOANLIMIT",
    //   button_name: "Set Loan Limit",
    //   Show_Button: true,
    //   permission: "hasNoPermission",
    //   roleGroupId: [1, 2, 3, 4, 5],
    // },
    ApproveDisapproveCustomer: {
      key: "APPROVEDISAPPROVECUSTOMER",
      button_name: "Approve/Disapprove Customer",
      Show_Button: true,
      permission: "ActivatePermission",
      //roleGroupId: [1, 2, 3, 4],
    },
    CustomerCharges: {
      key: "CustomerCharges",
      button_name: "Customer Charges",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4, 5],
    },
    MarkRegFeePaid: {
      key: "MARKREGFEEPAID",
      button_name: "MarkRegFeePaid",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2],
      companyIds: [29, 20, 64, 114],
    },
    dataObject: {
      ignoreFields,
      objectName: "fetchallApprovedAssetCustomers",
      parameters: "",
    },
    showMore: {
      objectname: "dynamicCustomerSearch",
      inputsubobjectname: "customer",
      parameters: "searchTerm",
      search: true,
      min: 3,
      max: 20,
      otherParams: 2,
      isCustomer: true,
      isAssetCustomer: 1,
    },
  };
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleOpenModal = () => {
    setDialogOpen(true);
  };

  return (
    <Box m="2px">
      <Box
        m="2px"
        sx={{
          justifyContent: "end",
          alignItems: "center",
          display: "flex",
        }}
      >
        {" "}
        <Typography style={{ color: colors.greenAccent[400], margin: "0 8px" }}>
          Import Customer(s)
        </Typography>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudUpload />}
          sx={{
            backgroundColor: colors.greenAccent[500],
            borderRadius: "4px",
            m: "10px",
          }}
          onClick={handleOpenModal}
        >
          <Typography style={{ color: colors.primary[400], margin: "0 8px" }}>
            Import
          </Typography>
        </Button>
      </Box>
      <DynamicTableForJson
        title="Approved Asset Customers"
        subtitle="View all Approved asset customers, create edit or view details"
        columns={columns}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Pass tour steps as prop
      />
    </Box>
  );
}

export default ApprovedAssetCustomers;
